import React, { useState } from 'react';
import api from '../services/api';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { toast } from 'react-toastify';
import '../styles/floatingForm.css';
import { useNavigate } from 'react-router-dom';

const CreatePlanInPage = () => { 
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // BASIC FIELDS
  const [planName, setPlanName] = useState('');
  const [price, setPrice] = useState('');
  const [noofpackge, setNoofpackge] = useState('');
  const [rank, setRank] = useState('');
  const [planetype, setPlanetype] = useState('Monthly');
  const [isActive, setIsActive] = useState('1');
  const [durationDays, setDurationDays] = useState('');
  const [planDescription, setPlanDescription] = useState('');

  // 🔥 FEATURES (NEW - SAME AS UPDATE)
  const [features, setFeatures] = useState([]);

  const handleCancel = () => {
    setPlanName('');
    setPrice('');
    setNoofpackge('');
    setRank('');
    setPlanetype('Monthly');
    setIsActive('1');
    setDurationDays('');
    setPlanDescription('');
    setFeatures([]);
    setErrors({});
    navigate('/plan-types');
  };

  // ✅ VALIDATION (MATCH UPDATE)
  const validateForm = () => {
    const newErrors = {};

    if (!planName.trim()) newErrors.planName = "Plan Name cannot be empty";
    if (!price.trim()) newErrors.price = "Price cannot be empty";
    if (isNaN(price)) newErrors.price = "Invalid price";

    if (!noofpackge.trim()) newErrors.noofpackge = "Required";
    if (isNaN(noofpackge)) newErrors.noofpackge = "Invalid";

    if (!rank.trim()) newErrors.rank = "Required";
    if (isNaN(rank)) newErrors.rank = "Invalid";

    if (!durationDays.trim()) newErrors.durationDays = "Required";
    if (isNaN(durationDays)) newErrors.durationDays = "Invalid";

    return newErrors;
  };

  // ✅ FEATURE HANDLERS
  const addFeature = () => {
    setFeatures([...features, { serviceplantitle: '', serviceplandiscription: '' }]);
  };

  const handleFeatureChange = (index, field, value) => {
    const updated = [...features];
    updated[index][field] = value;
    setFeatures(updated);
  };

  const removeFeature = (index) => {
    setFeatures(features.filter((_, i) => i !== index));
  };

  // ✅ SUBMIT (FORMDATA SAME AS UPDATE)
  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error("Please fill all required fields correctly");
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();

      // BASIC FIELDS
      formData.append("plan_name", planName);
      formData.append("price", price);
      formData.append("noofpackge", noofpackge);
      formData.append("rank", rank);
      formData.append("is_active", isActive);
      formData.append("duration_days", durationDays);
      formData.append("plan_discription", planDescription);
      formData.append("plan_type", planetype);

      // 🔥 FEATURES (IMPORTANT)
      features.forEach((f) => {
        formData.append("serviceplantitle[]", f.serviceplantitle || "");
        formData.append("serviceplandiscription[]", f.serviceplandiscription || "");
      });

      // DEBUG
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      await api.post(`/service-plan/add`, formData);

      toast.success("Plan created successfully!");
      handleCancel();

    } catch (error) {
      console.error(error);
      toast.error("Error creating plan");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='floating-form-container' >
      <div className="heading">
        <h2>Create Service Plan</h2>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-container">
          <div className="section-1">

            {/* PLAN NAME */}
            <div className="input-container-floating-form wid-50">
              <label>Plan Name *</label>
              <input value={planName} onChange={(e)=>setPlanName(e.target.value)} />
              {errors.planName && <span className='text-danger small'>{errors.planName}</span>}
            </div>

            {/* PRICE */}
            <div className="input-container-floating-form wid-50">
              <label>Price *</label>
              <input type="number" value={price} onChange={(e)=>setPrice(e.target.value)} />
              {errors.price && <span className='text-danger small'>{errors.price}</span>}
            </div>

            {/* PACKAGE */}
            <div className="input-container-floating-form wid-50">
              <label>Number of Packages *</label>
              <input type="number" value={noofpackge} onChange={(e)=>setNoofpackge(e.target.value)} />
            </div>

            {/* RANK */}
            <div className="input-container-floating-form wid-50">
              <label>Rank *</label>
              <input type="number" value={rank} onChange={(e)=>setRank(e.target.value)} />
            </div>

            {/* DURATION */}
            <div className="input-container-floating-form wid-50">
              <label>Duration (Days) *</label>
              <input type="number" value={durationDays} onChange={(e)=>setDurationDays(e.target.value)} />
            </div>

            {/* PLAN TYPE */}
            <div className="input-container-floating-form wid-50">
              <label>Plan Type *</label>
              <select value={planetype} onChange={(e)=>setPlanetype(e.target.value)}>
                <option value="Monthly">Monthly</option>
                <option value="Yearly">Yearly</option>
              </select>
            </div>

            {/* STATUS */}
            <div className="input-container-floating-form wid-50">
              <label>Status *</label>
              <select value={isActive} onChange={(e)=>setIsActive(e.target.value)}>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>



            {/* 🔥 FEATURES */}
            <div className="input-container-floating-form wid-100 mt-3 display-flex flex-direction-column">
              <label>Features *</label>

              <div className='action-btn button d-flex' style={{ marginBottom: "10px" }}>
                <button type="button" onClick={addFeature}>
                  + Add Feature
                </button>
              </div>

              {features.map((feature, index) => (
                <div key={index} className="feature-box" style={{ marginBottom: "15px" }}>

                  <input
                    type="text"
                    placeholder="Feature Title"
                    value={feature.serviceplantitle}
                    onChange={(e)=>handleFeatureChange(index,'serviceplantitle',e.target.value)}
                    className="input-container-floating-form wid-50 mb-2"
                  />

                  <input
                    type="text"
                    placeholder="Feature Description"
                    value={feature.serviceplandiscription}
                    onChange={(e)=>handleFeatureChange(index,'serviceplandiscription',e.target.value)}
                    className="input-container-floating-form wid-50 mb-2"
                  />


                  <hr />
                </div>
              ))}
            </div>

          </div>

          <div className="form-btn-container">
            <button type='submit' disabled={loading}>
              {loading ? 'Creating...' : 'Create Plan'}
            </button>
            <button type='button' onClick={handleCancel}>Cancel</button>
          </div>

        </div>
      </form>
    </div>
  );
};

export default CreatePlanInPage;